
import { EditorPodSession } from '../../app/canvas/EditorPodSession';
import { ClientManager } from './ClientManager';
import { Id, Manager, Pod, UserId } from './ClientSymbols';

export class Client {

    public [Id]: string;
    public [UserId]: string;
    public [Manager]: ClientManager;
    public [Pod]: EditorPodSession;

    public get id() {
        return this[Id];
    }

    public get userId() {
        return this[UserId];
    }

    public get self() {
        return false;
    }

    public get profile(): Readonly<Record<string, any>> {
        return new Proxy(this, {
            get(target, property) {
                return target.get(property?.toString());
            }
        });
    }

    public keys() {
        return Object.keys(this[Pod].getClientProfile(this.id));
    }

    public get(propertyKey: string): any {
        return this[Pod].getClientProfileValue(this.id, propertyKey);
    }
}
